var exports = {
  "kL": "CreateDMBottomSheet.module__container___cmhoTU",
  "XG": "CreateDMBottomSheet.module__scroller___cmhoTU",
  "Qs": "CreateDMBottomSheet.module__content___cmhoTU",
  "h_": "CreateDMBottomSheet.module__description___cmhoTU",
  "ov": "CreateDMBottomSheet.module__friendSelector___cmhoTU",
  "qr": "CreateDMBottomSheet.module__footer___cmhoTU",
  "x7": "CreateDMBottomSheet.module__cancelButton___cmhoTU",
  "Tf": "CreateDMBottomSheet.module__createButton___cmhoTU",
};

module.exports = exports;
